var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c("div", [_vm._t("default"), _vm._v(" "), _vm._m(0)], 2)
}
var staticRenderFns = [
  function () {
    var _vm = this,
      _c = _vm._self._c
    return _c(
      "a",
      {
        staticClass: "faq-back-to-top btn btn-secondary",
        attrs: { href: "#top" },
      },
      [_c("i", { staticClass: "fas fa-chevron-up" }), _vm._v(" Back to top")]
    )
  },
]
render._withStripped = true

export { render, staticRenderFns }